import {memo} from "react";
import Arrow from "@/public/arrow.svg";
import StrapiImage from "../../../../_components/StrapiImage";
import StaffMember from "../../../../types/StaffMember";
import Image from "next/image";

// Static card.  No interactions.  Just an individual card.
const StaticCampusStaffCard: React.FC<StaffMember> = ({
	image,
	alternativeImageSrc,
	name,
	role,
}) => {
	const imageStyleClass =
		"h-[178px] w-full object-cover grayscale transition-all group-hover:grayscale-0 group-focus:grayscale-0 motion-safe:group-hover:rounded-br-[90px] motion-safe:group-focus:rounded-br-[90px] lg:h-[198px] xl:h-[248px]";
	return (
		<div className="border-b-2 border-solid border-orange-700/0 bg-orange-100/0 text-left transition-all group-hover:border-orange-700/100 group-hover:bg-orange-100/100 group-focus:border-orange-700/100 group-focus:bg-orange-100/100">
			<div className="relative">
				{image && (
					<StrapiImage
						width="300"
						height="300"
						image={image.data}
						className={imageStyleClass}
					/>
				)}
				{!image && alternativeImageSrc && (
					<Image
						alt={`${name}'s headshot`}
						src={alternativeImageSrc}
						width={178}
						height={178}
						className={imageStyleClass}
					/>
				)}
				<Arrow
					viewBox="0 0 64 64"
					className="absolute right-[-10%] top-[105%] hidden max-h-[20%] -rotate-[110deg] fill-orange-700 pt-1 opacity-0 transition-all group-hover:opacity-100 group-focus:opacity-100 motion-safe:pt-0 xs:block md:hidden lg:right-[-14%] lg:block xl:right-[-10%]"
				/>
			</div>
			<div className="mt-2 py-2 transition-all group-hover:pl-2 group-hover:pr-2 group-focus:pl-2 group-focus:pr-2 group-hover:xs:pr-10 group-focus:xs:pr-10 group-hover:md:pr-2 group-focus:md:pr-2 group-hover:lg:pr-10 group-focus:lg:pr-10">
				<h6>{name}</h6>
				<p className="text-gray-700">{role}</p>
			</div>
		</div>
	);
};

export default memo(StaticCampusStaffCard);
